/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

type Props = {
  className: string;
  onClick: () => void;
};

export const NextArrow = (props: Props) => {
  const { className, onClick } = props;
  // TODO: Please fix the a11y issues with this element and then remove the comments at the top of the file.
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        background: `url(${process.env.REACT_APP_ASSETS_BASE_URL}/images/next-arrow.png) no-repeat`,
        backgroundSize: 'contain',
      }}
    />
  );
};

export const PrevArrow = (props: Props) => {
  const { className, onClick } = props;
  // TODO: Please fix the a11y issues with this element and then remove the comments at the top of the file.
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        background: `url(${process.env.REACT_APP_ASSETS_BASE_URL}/images/prev-arrow.png) no-repeat`,
        backgroundSize: 'contain',
      }}
    />
  );
};
